import React from 'react';
import {
  GlobeAltIcon,
  BuildingOffice2Icon,
  TruckIcon,
  ExclamationTriangleIcon,
  WrenchScrewdriverIcon,
  ShieldCheckIcon,
  CogIcon,
  MapPinIcon,
  ServerStackIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import { IndustryPageTemplate } from '../../components/page-templates/MarketPageTemplates';

const challenges = [
  {
    icon: MapPinIcon,
    title: 'Remote Industrial Sites',
    description: 'Deploying ICT equipment to factories, plants, and industrial sites in hard-to-reach locations worldwide.',
  },
  {
    icon: ExclamationTriangleIcon,
    title: 'Import Regulation Complexity',
    description: 'Varied import regulations across manufacturing regions create compliance risk for every shipment.',
  },
  {
    icon: CogIcon,
    title: 'Specialised Equipment Handling',
    description: 'Rugged and industrial-grade ICT equipment that requires specialised packaging, handling, and transport.',
  },
  {
    icon: ClockIcon,
    title: 'Uptime Requirements',
    description: 'Manufacturing operations cannot afford downtime, ICT equipment must arrive and function on schedule.',
  },
];

const solutions = [
  {
    icon: TruckIcon,
    title: 'Project-Based Freight & Consolidation',
    description: 'Coordinated shipping for factory rollouts, consolidating multi-vendor equipment into single deliveries.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'IOR/EOR for Manufacturing Markets',
    description: 'Full import/export compliance across manufacturing hubs in Asia, Europe, and the Americas.',
  },
  {
    icon: BuildingOffice2Icon,
    title: 'Destination Warehousing',
    description: 'Strategic warehouse locations near industrial zones for staging, consolidation, and just-in-time delivery.',
  },
  {
    icon: WrenchScrewdriverIcon,
    title: 'On-Site Installation by L1 Engineers',
    description: 'Trained field engineers for equipment installation, testing, and handover at industrial facilities.',
  },
  {
    icon: ServerStackIcon,
    title: 'Rack & Stack Services',
    description: 'Professional rack mounting, cabling, and commissioning for industrial ICT infrastructure.',
  },
  {
    icon: GlobeAltIcon,
    title: 'Global Project Coordination',
    description: 'Single point of contact for multi-site deployments spanning multiple countries and time zones.',
  },
];

const stats = [
  { value: '140+', label: 'Countries' },
  { value: '6', label: 'Global Offices' },
  { value: '10+', label: 'Years Experience' },
  { value: '6,500+', label: 'Field Workers' },
];

const IndustrialManufacturing: React.FC = () => (
  <IndustryPageTemplate
    eyebrow="Industrial & Manufacturing"
    title="ICT Logistics for Industrial & Manufacturing Operations"
    highlight="Industrial & Manufacturing"
    description="Reliable, compliant logistics for deploying and managing ICT infrastructure across factories, plants, and industrial sites worldwide."
    heroIcon={CogIcon}
    heroAccentIcon={GlobeAltIcon}
    challengesIntro="Industrial operations demand logistics that can handle remote locations, tight timelines, and complex compliance."
    challenges={challenges}
    solutionsIntro="Execution support designed for factory environments, industrial uptime requirements, and complex deployment footprints."
    solutions={solutions}
    useCase="From smart factory deployments to industrial IoT rollouts, TrueLog ensures your ICT equipment reaches every site on time, configured, and ready to operate."
    stats={stats}
    ctaTitle="Ready to modernise your industrial ICT logistics?"
    ctaDescription="Let TrueLog handle the logistics so your manufacturing operations stay connected and productive."
  />
);

export default IndustrialManufacturing;
